<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="PDM出错责任榜 center_6"
      :rightTitle="`${formatTime(date, 'yyyy年MM月')} 合计：${totalNum}`"
      :tooltipText="'售后统计实时数据'"
    ></chart-title>
    <date-change-card
      style="padding: 0 10px"
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div id="center_6" slot="main" />
    </date-change-card>
  </div>
</template>

<script>
import {orderPerson} from "@/api/cockpit/jyl";
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
import {formatTime, getFirstDate, getNextMonth} from "@/utils";
export default {
  mixins: [resize],
  name: "center_6",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      date: new Date(),
      totalNum: 0,
      chart: null,
      xData: [],
      chartData: []
    };
  },
  props: {},
  created() {},
  mounted() {
    this.getData();
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    formatTime,
    getData(){

      //初始化数据
      this.totalNum = 0;
      this.xData = [];
      this.chartData = [];

      //获取ERP 接口数据
      orderPerson(
          {'dayTime':getFirstDate(this.date, "yyyy-MM-dd")}
      ).then((resp) => {
        //处理数据
        for (let key in resp.data) {
          this.totalNum += resp.data[key].count;
          this.xData.push(resp.data[key].name);
          this.chartData.push({value: resp.data[key].count})
        }

        this.initChart();
      });

    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("center_6"));
      this.setOptions();
    },
    setOptions() {
      const color = ["0, 157, 255", "34, 228, 255", "59, 255, 208"];
      let chartData = this.chartData.map((m, i) => {
        return {
          value: m.value,
          itemStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
              { offset: 0, color: `rgba(${color[i % 3]},0.1)` },
              { offset: 1, color: `rgba(${color[i % 3]},1)` },
            ]),
          },
        };
      });

      this.chart.setOption({
        color: ["#009dff", "#22e4ff", "#3bffd0"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        grid: {
          left: "12%",
          right: "12%",
          top: "14%",
          bottom: "9%",
          containLabel: true,
        },
        legend: {
          show: false,
          data: ["出错数量"],
          bottom: "3%",
          textStyle: {
            color: "#606266",
            fontSize: "10",
          },
        },
        xAxis: [
          {
            type: "category",
            data: this.xData,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              color: "#909399",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            interval: 50,
            axisLabel: {
              color: "#606266",
              fontSize: "10",
            },
            axisLine: {
              lineStyle: {
                color: "#606266",
              },
            },
            splitLine: {
              lineStyle: {
                color: "#606266",
                type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
              },
            },
          },
          {
            show: false,
          },
        ],
        series: [
          {
            name: "出错数量",
            type: "bar",
            barWidth: 5,
            itemStyle: {
              borderRadius: 5,
            },
            data: chartData,
          },
        ],
      });
    },
    //前一月
    leftClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), -1);
      this.getData();
    },
    //后一月
    rightClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), +1);
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 26vh;
  #center_6 {
    height: 100%;
  }
}
</style>
